import config from 'config';

import { getHashedIndex } from '@lyearn/core/utils/hashCode';
import { CreateMediaInput, MediaKindEnum, ResourceTypeEnum } from '@/types/schema';

export const CARD_IMAGES = {
  [ResourceTypeEnum.Article]: [
    `${config.cdn_domain}/assets/images/cards/article-card-01.svg`,
    `${config.cdn_domain}/assets/images/cards/article-card-02.svg`,
    `${config.cdn_domain}/assets/images/cards/article-card-03.svg`,
    `${config.cdn_domain}/assets/images/cards/article-card-04.svg`,
    `${config.cdn_domain}/assets/images/cards/article-card-05.svg`,
    `${config.cdn_domain}/assets/images/cards/article-card-06.svg`,
  ],
  [ResourceTypeEnum.Checkin]: [
    `${config.cdn_domain}/assets/images/cards/checkin-card-01.svg`,
    `${config.cdn_domain}/assets/images/cards/checkin-card-02.svg`,
    `${config.cdn_domain}/assets/images/cards/checkin-card-03.svg`,
    `${config.cdn_domain}/assets/images/cards/checkin-card-04.svg`,
    `${config.cdn_domain}/assets/images/cards/checkin-card-05.svg`,
    `${config.cdn_domain}/assets/images/cards/checkin-card-06.svg`,
  ],
  [ResourceTypeEnum.Course]: [
    `${config.cdn_domain}/assets/images/cards/course-card-01.svg`,
    `${config.cdn_domain}/assets/images/cards/course-card-02.svg`,
    `${config.cdn_domain}/assets/images/cards/course-card-03.svg`,
    `${config.cdn_domain}/assets/images/cards/course-card-04.svg`,
    `${config.cdn_domain}/assets/images/cards/course-card-05.svg`,
    `${config.cdn_domain}/assets/images/cards/course-card-06.svg`,
  ],
  [ResourceTypeEnum.ExternalContent]: [
    `${config.cdn_domain}/assets/images/cards/external-content-01.svg`,
    `${config.cdn_domain}/assets/images/cards/external-content-02.svg`,
    `${config.cdn_domain}/assets/images/cards/external-content-03.svg`,
    `${config.cdn_domain}/assets/images/cards/external-content-04.svg`,
    `${config.cdn_domain}/assets/images/cards/external-content-05.svg`,
    `${config.cdn_domain}/assets/images/cards/external-content-06.svg`,
  ],
  [ResourceTypeEnum.Scorm]: [
    `${config.cdn_domain}/assets/images/cards/external-content-01.svg`,
    `${config.cdn_domain}/assets/images/cards/external-content-02.svg`,
    `${config.cdn_domain}/assets/images/cards/external-content-03.svg`,
    `${config.cdn_domain}/assets/images/cards/external-content-04.svg`,
    `${config.cdn_domain}/assets/images/cards/external-content-05.svg`,
    `${config.cdn_domain}/assets/images/cards/external-content-06.svg`,
  ],
  [ResourceTypeEnum.Exercise]: [
    `${config.cdn_domain}/assets/images/cards/submission-card-01.svg`,
    `${config.cdn_domain}/assets/images/cards/submission-card-02.svg`,
    `${config.cdn_domain}/assets/images/cards/submission-card-03.svg`,
    `${config.cdn_domain}/assets/images/cards/submission-card-04.svg`,
    `${config.cdn_domain}/assets/images/cards/submission-card-05.svg`,
    `${config.cdn_domain}/assets/images/cards/submission-card-06.svg`,
  ],
  [ResourceTypeEnum.Path]: [
    `${config.cdn_domain}/assets/images/cards/path-card-01.svg`,
    `${config.cdn_domain}/assets/images/cards/path-card-02.svg`,
    `${config.cdn_domain}/assets/images/cards/path-card-03.svg`,
    `${config.cdn_domain}/assets/images/cards/path-card-04.svg`,
    `${config.cdn_domain}/assets/images/cards/path-card-05.svg`,
    `${config.cdn_domain}/assets/images/cards/path-card-06.svg`,
  ],
  [ResourceTypeEnum.Quiz]: [
    `${config.cdn_domain}/assets/images/cards/quiz-card-01.svg`,
    `${config.cdn_domain}/assets/images/cards/quiz-card-02.svg`,
    `${config.cdn_domain}/assets/images/cards/quiz-card-03.svg`,
    `${config.cdn_domain}/assets/images/cards/quiz-card-04.svg`,
    `${config.cdn_domain}/assets/images/cards/quiz-card-05.svg`,
    `${config.cdn_domain}/assets/images/cards/quiz-card-06.svg`,
  ],
  [ResourceTypeEnum.Survey]: [
    `${config.cdn_domain}/assets/images/cards/survey-card-01.svg`,
    `${config.cdn_domain}/assets/images/cards/survey-card-02.svg`,
    `${config.cdn_domain}/assets/images/cards/survey-card-03.svg`,
    `${config.cdn_domain}/assets/images/cards/survey-card-04.svg`,
    `${config.cdn_domain}/assets/images/cards/survey-card-05.svg`,
    `${config.cdn_domain}/assets/images/cards/survey-card-06.svg`,
  ],
  [ResourceTypeEnum.Task]: [
    `${config.cdn_domain}/assets/images/cards/task-card-01.svg`,
    `${config.cdn_domain}/assets/images/cards/task-card-02.svg`,
    `${config.cdn_domain}/assets/images/cards/task-card-03.svg`,
    `${config.cdn_domain}/assets/images/cards/task-card-04.svg`,
    `${config.cdn_domain}/assets/images/cards/task-card-05.svg`,
    `${config.cdn_domain}/assets/images/cards/task-card-06.svg`,
  ],
  [ResourceTypeEnum.Roleplay]: [
    `${config.cdn_domain}/assets/images/cards/checkin-card-01.svg`,
    `${config.cdn_domain}/assets/images/cards/checkin-card-02.svg`,
    `${config.cdn_domain}/assets/images/cards/checkin-card-03.svg`,
    `${config.cdn_domain}/assets/images/cards/checkin-card-04.svg`,
    `${config.cdn_domain}/assets/images/cards/checkin-card-05.svg`,
    `${config.cdn_domain}/assets/images/cards/checkin-card-06.svg`,
  ],
  EVENT: [
    `${config.cdn_domain}/assets/images/cards/session-card-01.svg`,
    `${config.cdn_domain}/assets/images/cards/session-card-02.svg`,
    `${config.cdn_domain}/assets/images/cards/session-card-03.svg`,
    `${config.cdn_domain}/assets/images/cards/session-card-04.svg`,
    `${config.cdn_domain}/assets/images/cards/session-card-05.svg`,
    `${config.cdn_domain}/assets/images/cards/session-card-06.svg`,
  ],
  FILE: [
    `${config.cdn_domain}/assets/images/cards/checkin-card-01.svg`,
    `${config.cdn_domain}/assets/images/cards/checkin-card-02.svg`,
    `${config.cdn_domain}/assets/images/cards/checkin-card-03.svg`,
    `${config.cdn_domain}/assets/images/cards/checkin-card-04.svg`,
    `${config.cdn_domain}/assets/images/cards/checkin-card-05.svg`,
    `${config.cdn_domain}/assets/images/cards/checkin-card-06.svg`,
  ],
  MODULE: [
    `${config.cdn_domain}/assets/images/cards/path-card-01.svg`,
    `${config.cdn_domain}/assets/images/cards/path-card-02.svg`,
    `${config.cdn_domain}/assets/images/cards/path-card-03.svg`,
    `${config.cdn_domain}/assets/images/cards/path-card-04.svg`,
    `${config.cdn_domain}/assets/images/cards/path-card-05.svg`,
    `${config.cdn_domain}/assets/images/cards/path-card-06.svg`,
  ],
};

const IMAGES_SET = new Set(
  Object.keys(CARD_IMAGES).reduce(
    (images, content) => [...images, ...CARD_IMAGES[content as keyof typeof CARD_IMAGES]],
    [] as string[],
  ),
);

export function isDefaultImage(url?: string | null) {
  if (!url) {
    return false;
  }
  const parsedUrl = new URL(url);
  return IMAGES_SET.has(parsedUrl.origin + parsedUrl.pathname);
}

export function getRandomCardImage(type: keyof typeof CARD_IMAGES): CreateMediaInput {
  const images =
    type in CARD_IMAGES
      ? // @ts-ignore
        CARD_IMAGES[type]
      : CARD_IMAGES[ResourceTypeEnum.Course]; // fallback to random course image if type in not in CARD_IMAGE

  return {
    kind: MediaKindEnum.Image,
    url: images[Math.floor(Math.random() * images.length)],
  };
}

export const getHashedCardImage = (contentName: string, type: keyof typeof CARD_IMAGES) => {
  const index = getHashedIndex(contentName || '', 6);
  const images =
    type in CARD_IMAGES
      ? // @ts-ignore
        CARD_IMAGES[type]
      : CARD_IMAGES[ResourceTypeEnum.Course];

  return images[index];
};
